import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type FacialBloodScanMetadataState = {
  facialBloodScanCount?: number;
  hasDateOfBirth?: boolean;
  hasCompletedQuestionnaire?: boolean;
};

const initialState: FacialBloodScanMetadataState = {};

const facialBloodScanMetadataSlice = createSlice({
  name: "facialBloodScanMetadata",
  initialState,
  reducers: {
    setFacialBloodScanMetadata(
      state,
      action: PayloadAction<FacialBloodScanMetadataState>
    ) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setFacialBloodScanMetadata } =
  facialBloodScanMetadataSlice.actions;

export default facialBloodScanMetadataSlice;
